module.exports = "\n<app-parser></app-parser>"